/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { IDefinition } from '../../../models/common/IDefinition';
import { Parameter } from '../../../models/common/Parameter';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { Oas30Parameter } from '../../../../openapi/v3/models/Oas30Parameter';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasParameterExamplesMutualExclusivityRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        let param : Oas30Parameter = <Oas30Parameter>node;
        this.reportIf(this.hasValue(param.example) && /* size */(<number>param.getExamples().length) > 0, node, Constants.PROP_EXAMPLE, this.map.apply(this, ));
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.visitParameter(<Parameter><any>node);
    }
}
OasParameterExamplesMutualExclusivityRule["__class"] = "io.apicurio.datamodels.core.validation.rules.mutex.OasParameterExamplesMutualExclusivityRule";
OasParameterExamplesMutualExclusivityRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




